module.exports = __webpack_public_path__ + "img/5-4.e6992244.svg";